export default __webpack_public_path__ + "static/media/Path 339.24d5891a.svg";